import GlobalStoreService from "../services/global-store.service";
import { globalConstants } from "../constants/globalConstants";
import PlatformType from '../enums/PlatformType';
import { static_links } from '../constants/static_links';
import BotType from '../enums/BotType';
import IdleTimeoutService from "../services/idle-timeout.service";
import TrackingMiddlewareService from "./tracking-middleware.service";
import TrackingKey from '../enums/trackingKey'
import TrackingPlatform from '../enums/TrackingPlatform'
import GLOBAL_CONFIG from '../config/config';

export default class UtilService {

  static getCurrentTime() {

    const date = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let timestamp = date.getTime()

    const ampm = hours >= 12 ? "pm" : "am";
    hours %= 12;
    if (!hours) {
      hours = 12;
    }
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    const strTime = `${hours}:${minutes} ${ampm}`;
    return { time_in_format: strTime, timestamp };
  };



  static getOS() {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
    const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
    const iosPlatforms = ["iPhone", "iPad", "iPod"];
    let os = null;
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }
    return os;
  }

  static getPlatformTypeForTracking() {
    let os = this.getOS();
    if ((window.MyAirtelAppReact) || (window.MyAirtelChatAppReact)) {
      //app context
      switch (os) {
        case "iOS":
          return TrackingPlatform.IOS_WEBVIEW
        case "Android":
          return TrackingPlatform.ANDROID_WEBVIEW
      }
    }
    else {
      //web cases
      switch (os) {
        case "iOS":
          return TrackingPlatform.IOS_MSITE
        case "Android":
          return TrackingPlatform.ANDROID_MSITE
        default:
          return TrackingPlatform.WEB
      }
    }
  }

  static getPlatformType() {
    switch (this.getOS()) {
      case "iOS":
        return PlatformType.IOS;
      case "Android":
        return PlatformType.ANDROID;
      default:
        return PlatformType.WEB;
    }
    return PlatformType.WEB;
  }

  static escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  static replaceAll(str, term, replacement) {
    return str.replace(new RegExp(this.escapeRegExp(term), "g"), replacement);
  };

  static handleDtLink(handleDtLinkClick) {
    if (
      document.querySelectorAll("a[href^='executeDT']") &&
      document.querySelectorAll("a[href^='executeDT']")[0]
    ) {
      for (
        let i = 0;
        i < document.querySelectorAll("a[href^='executeDT']").length;
        i += 1
      ) {
        document
          .querySelectorAll("a[href^='executeDT']")
        [i].addEventListener("click", event => {
          IdleTimeoutService.updateIdleState();
          if (!event.target.disabled) {
            const paramsCount = event.target.href.split("/").length;
            // eslint-disable-next-line
            event.target["disabled"] = true;
            event.preventDefault();
            if (GlobalStoreService.get("isUserLoggedIn")) {
              // ALREADY LOGGED IN AND CONFIRMED HIS NUMBER ----  INITIATE SCENARIO
              let scenarioId = event.target.href.split("/")[
                paramsCount - 1
              ]
              handleDtLinkClick(
                {
                  actionType: "INITIATE",
                  scenarioResponse: {
                    scenarioId: event.target.href.split("/")[
                      paramsCount - 1
                    ],
                    scenarioName: ""
                  }
                }
              );

              // TRACKING EXECUTE DT
              let user_response = document.querySelectorAll("a[href^='executeDT']")[i].title ? document.querySelectorAll("a[href^='executeDT']")[i].title : ""

              TrackingMiddlewareService.setTrackingData({ enteredTextMode: 'click', scenarioStrategy: "DTScenario", scenarioName: scenarioId })
              TrackingMiddlewareService.trackEvent(TrackingKey.LINK_CLICKS)
            } else {
              handleDtLinkClick(
                {
                  actionType: "ASK_FOR_LOGIN",
                  scenarioResponse: {
                    scenarioId: event.target.href.split("/")[
                      paramsCount - 1
                    ],
                    scenarioName: ""
                  }
                }
              );
            }
          } else {
            event.preventDefault();
          }
        });
      }
    }

    // TRACK NORMAL LINKS
    const normalLinksList = document.querySelectorAll("a:not([href^='executeDT'])");
    if (normalLinksList
      && normalLinksList[0]) {
      for (let i = 0; i < normalLinksList.length; i += 1) {
        normalLinksList[i].addEventListener("click", event => {
          if (normalLinksList[i].href && normalLinksList[i].href !== 'javascript:void(0)') {
            try {
              IdleTimeoutService.updateIdleState();
              let user_response = normalLinksList[i].title ? normalLinksList[i].title : ""
              TrackingMiddlewareService.trackEvent(TrackingKey.LINK_CLICKS)
            } catch (e) {
              console.log(e);
            }
          }
        });
      }
    }
  }

  static isCountryTemplate(templateList) {
    return (
      templateList.includes(globalConstants.Scenario_Template_List.IR_Pack_Countries) ?
        true :
        false
    );
  }

  static IS_IR_RECO_DYN_PARAM(templateList) {
    return (
      templateList.includes(globalConstants.Scenario_Template_List.IR_RECO_DYN_PARAM) ?
        true :
        false
    );
  }

  static IS_IR_PACKS_RECO(templateList) {
    return (
      templateList.includes(globalConstants.Scenario_Template_List.IR_PACKS_RECO) ?
        true :
        false
    );
  }

  static IS_IR_PACKS_ALL(templateList) {
    return (
      templateList.includes(globalConstants.Scenario_Template_List.IR_PACKS_ALL) ?
        true :
        false
    );
  }

  static createDynamicData(templateList, userInput) {
    switch (true) {
      case this.isCountryTemplate(templateList):
        return {
          "INPUT_PARAM-IR_BOOSTER_COUNTRY_NAME": userInput
        };
      case this.IS_IR_RECO_DYN_PARAM(templateList):
        return {
          "INPUT_PARAM-IR_BOOSTER_VALIDITY": userInput
        };
      case this.IS_IR_PACKS_RECO(templateList):
        return {
          "INPUT_PARAM-IR_BOOSTER_ID_ACTIVE_REQUEST": userInput
        };
      case this.IS_IR_PACKS_ALL(templateList):
        return {
          "INPUT_PARAM-IR_BOOSTER_ID_ACTIVE_REQUEST": userInput
        };
      case templateList.includes('IR_ACTIVATED_PACKS_DEACTIVATION'):
        return {
          "DEACTIVATION_IR_PACK_ID": userInput
        }
      default:
        return {
        };
    }
  }

  static htmlEncode(inputString) {
    if (inputString === null || inputString.length === 0) {
      /* eslint-disable */
      inputString = "";
    }
    let finalString = "";
    const inputStringLength = inputString.length;
    // Allow: a-z A-Z 0-9
    // Allow (dec): 97-122 65-90 48-57
    for (let i = 0; i < inputStringLength; i += 1) {
      const currentCharacter = inputString.charCodeAt(i);
      if ((currentCharacter >= 97 && currentCharacter <= 122) ||
        (currentCharacter >= 65 && currentCharacter <= 90) ||
        (currentCharacter >= 48 && currentCharacter <= 57)) {
        // eslint-disable-next-line
        finalString += inputString.charAt(i);
      } else {
        // eslint-disable-next-line
        finalString += '&#' + currentCharacter + ';';
      }
    }

    return finalString;
  }

  static getPlatformWiseLinkForPlanDeatils() {
    const platformType = GlobalStoreService.get("platformType");
    switch (platformType) {
      case PlatformType.WEB:
        return static_links.plan_rental.WEB
        return static_links.plan_rental.ANDROID.replace("{mobile}", GlobalStoreService.get("currentNumber"));
      case PlatformType.ANDROID:
        return static_links.plan_rental.ANDROID.replace("{mobile}", GlobalStoreService.get("currentNumber"));
      case PlatformType.IOS:
        return static_links.plan_rental.IOS.replace("{mobile}", GlobalStoreService.get("currentNumber"));
    }
  };

  static userProfileHasValidProducts(userProfile) {
    if (UtilService.isSingleAccount(userProfile) || UtilService.isMultipleAccount(userProfile)) {
      return true
    }
    return false
  }

  static isMultipleAccount(userProfile) {
    let noOfAccounts = 0;
    if (userProfile && userProfile.products) {
      for (i = 0; i < GLOBAL_CONFIG.lob_list.length; i++) {
        if (userProfile && userProfile.products && userProfile.products.hasOwnProperty(GLOBAL_CONFIG.lob_list[i])) {
          noOfAccounts += userProfile.products[GLOBAL_CONFIG.lob_list[i]].length;
        }
      }
    }
    if (noOfAccounts > 1) return true;
    return false;
  }

  static isSingleAccount(userProfile) {
    let noOfAccounts = 0;
    if (userProfile && userProfile.products) {
      for (i = 0; i < GLOBAL_CONFIG.lob_list.length; i++) {
        if (userProfile && userProfile.products && userProfile.products.hasOwnProperty(GLOBAL_CONFIG.lob_list[i])) {
          noOfAccounts += userProfile.products[GLOBAL_CONFIG.lob_list[i]].length;
        }
      }
    }

    if (noOfAccounts === 1) return true;
    return false;
  }

  static isPrepaidEnabled() {
    if (GLOBAL_CONFIG.lob_list.includes('PREPAID')) {
      return true
    }
    else
      return false
  }

  static insertAccountTypeInfo(accounts, type) {
    accounts.forEach(element => {
      if (type === BotType.POSTPAID && element.isSiebel && element.isSiebel === "true") {
        element["type"] = BotType.SIEBEL;
      }
      else {
        element["type"] = type;
      }
    });
  }

  static getUserProfileNumbersWithAccountType(profile) {
    let userProfile = profile || GlobalStoreService.get('userProfile');
    let numbers = []
    if (userProfile && userProfile.products) {
      for (let i = 0; i < GLOBAL_CONFIG.lob_list.length; i++) {
        if (userProfile && userProfile.products && userProfile.products.hasOwnProperty(GLOBAL_CONFIG.lob_list[i])) {
          let product_numbers = userProfile.products[GLOBAL_CONFIG.lob_list[i]]
          UtilService.insertAccountTypeInfo(product_numbers, GLOBAL_CONFIG.lob_list[i]);
          numbers = [...numbers, ...product_numbers]
        }
      }
    }
    return numbers
  }

  static allowUserLogin(loginResult, mobNo) {
    let primaryNumber = loginResult && loginResult.userProfile && loginResult.userProfile.userAuthToken && loginResult.userProfile.userAuthToken.primaryMsisdn ?
      loginResult.userProfile.userAuthToken.primaryMsisdn : mobNo ? mobNo : undefined
    if (primaryNumber && loginResult.userProfile && loginResult.userProfile.products) {
      switch (UtilService.getAccountNumberType(primaryNumber, loginResult.userProfile)) {
        case 'POSTPAID': {
          //ALLOW FOR POASTPAID primary number
          return true;
        }
        case 'PREPAID': {
          // allow for prepaid primary number
          return false;
        }
        case 'SIEBEL': {
          // allow for postpaid siebel primary number
          return true
        }
        default: {
          return false;
          // dont allow for null value
        }
      }
    }
    return false
  }


  static getBotType(mobNo, userProfile) {

    userProfile = userProfile ? userProfile : GlobalStoreService.get("userProfile")
    let numberType = UtilService.getAccountNumberType(mobNo, userProfile)

    if (numberType === BotType.POSTPAID) {
      return BotType.POSTPAID
    }
    else if (numberType === BotType.PREPAID) {
      return BotType.PREPAID
    }
    else if (numberType === BotType.SIEBEL) {
      return BotType.SIEBEL
    }
    else {
      return BotType.POSTPAID;
    }
  }

  static getAccountNumberType(mobNo, userProfile) {

    userProfile = userProfile ? userProfile : GlobalStoreService.get("userProfile")

    if (mobNo && userProfile && userProfile.products && Object.keys(userProfile.products).length > 0) {
      for (let i = 0; i < Object.keys(userProfile.products).length; i++) {
        let productKey = Object.keys(userProfile.products)[i]
        for (let j = 0; j < userProfile.products[productKey].length; j++) {
          if (userProfile.products[productKey][j].siNumber === mobNo) {
            // console.log('account type number', productKey)

            if (productKey.toUpperCase() === BotType.POSTPAID && userProfile.products[productKey][j].isSiebel && userProfile.products[productKey][j].isSiebel === "true") {
              return BotType.SIEBEL
            }
            else {
              return productKey.toUpperCase();
            }
          }
        }
      }
    }
    return null
  }

  static getTotalSessionTimeInSeconds() {
    return (new Date().getTime() - GlobalStoreService.get("trackingData").startTime.getTime()) / 1000;
  }

  static generateUniqueSessionId() {
    var date = new Date();
    var components = [
      date.getYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    ];
    return (components.join("") + Math.random() + Math.random()).replace(".", "").replace(".", "");
  }

  static refreshLoginToken() {
    const method = "GET";
    const uri =
      "https://api.myairtelapp.bsbportal.in/myairtelapp/v2/home/mainAccCard?density=XXHDPI";
    const payload = "";
    let app_reference = GlobalStoreService.get("APP_CONTEXT")
    let appHeaders = app_reference.getHeaders(
      method,
      uri,
      payload
    );
    appHeaders = String(appHeaders).replace(/\n/g, "");
    appHeaders = JSON.parse(appHeaders);
    const headers = {
      "x-bsy-dt": String(appHeaders["x-bsy-dt"]).replace(/\n/g, ""),
      "x-bsy-utkn1": String(appHeaders["x-bsy-utkn"]).replace(/\n/g, ""),
      "x-bsy-did": String(appHeaders["x-bsy-did"]).replace(/\n/g, "")
    };

    let newappHeaders = app_reference.getHeaders(
      method,
      "https://www.airtel.in/app/wl-service/airtel-digital-profile/rest/customer/profile/v2/rtn/fetch",
      ""
    );
    newappHeaders = String(newappHeaders).replace(/\n/g, "");
    newappHeaders = JSON.parse(newappHeaders);
    headers["x-bsy-utkn2"] = String(newappHeaders["x-bsy-utkn"]).replace(/\n/g, "");

    ChatBotApiService.getChatTokenForApp(headers).then((result) => {
      if (result && result.access_token) {
        GlobalStoreService.set("loggedInToken", "Bearer" + result.access_token);
      }
    }, err => {
      console.log(err);
    });
  }

  static isResponseEmpty(response) {

    let final = response.replace(/<(\/?)([a-z]*)([A-Z]*)>/g, '')
    // console.log(final)
    if (final.trim() === "") {
      return true
    }
    else
      return false

  }

  static getSpeechResponse(response) {
    let final = response.replace(/<(\/?)([a-z]*)([A-Z]*)>/g, '')
    return final
  }

  static getCategoryFaqPlatformResponse(category_object) {
    const platformType = GlobalStoreService.get("platformType");
    let finalResult
    if (platformType === PlatformType.ANDROID) {
      if (GlobalStoreService.get("APP_CONTEXT") && category_object.android) {
        const replaceString = "{mobile}";
        finalResult = this.replaceAll(
          category_object.android,
          replaceString,
          GlobalStoreService.get("currentNumber")
        );
        return finalResult;
      } else if (!GlobalStoreService.get("APP_CONTEXT") && category_object.web) {
        const replaceString = "{mobile}";
        finalResult = this.replaceAll(
          category_object.web,
          replaceString,
          GlobalStoreService.get("currentNumber")
        );
        return finalResult;
      }
    } else if (platformType === PlatformType.IOS) {
      if (GlobalStoreService.get("APP_CONTEXT") && category_object.ios) {
        const replaceString = "{mobile}";
        finalResult = this.replaceAll(
          category_object.ios,
          replaceString,
          GlobalStoreService.get("currentNumber")
        );
        return finalResult;
      }
      else if (!GlobalStoreService.get("APP_CONTEXT") && category_object.web) {
        const replaceString = "{mobile}";
        finalResult = this.replaceAll(
          category_object.web,
          replaceString,
          GlobalStoreService.get("currentNumber")
        );
        return finalResult;
      }
    }
    return category_object.web;

  }


  static hasTemplateDisableInput(templateList) {
    if (templateList.includes('DISABLE_INPUT')) {
      return true
    }
    else return false
  }

  static checkIfRedirectCase() {
    var params = new URLSearchParams(window.location.search)
    if (params.get("changePlanStatus")) {
      return "changePlanRedirectCase"
    }
    else if (params.get("transactionStatus")) {
      return "paymentTransactionRedirectCase"
    }
    else
      return undefined
  }

  static getParamValue(key) {

    var params = new URLSearchParams(window.location.search)
    let value = params.get(key)
    return value ? value : null

  }

  static removeSourceAndUriParamsFromLink(link) {
    let startLink = link.split('?')[0]
    let queryString = link.split('?')[1]

    // console.log(startLink,queryString)

    let params = queryString.split('&')
    params = params.filter(param => !(param.indexOf('source=') !== -1 || param.indexOf('uri=') !== -1))

    let newQueryString = '?' + params.join('&')
    let newLink = startLink + newQueryString

    return newLink

  }

  static getAccountsForBotType = (userProfile, BotType) => {
    let botTypeAccounts = []
    BotType = BotType.toUpperCase()
    if (userProfile && userProfile.products && userProfile.products[BotType]) {
      botTypeAccounts = userProfile.products[BotType]
    }
    return botTypeAccounts

  }


  static checkIfInitializationParamsMissing() {
    let scenarioList = GlobalStoreService.get('scenarioList');
    if (!GlobalStoreService.get('basicToken')) {
      return true
    }
    if (!scenarioList || (scenarioList && (!scenarioList[GlobalStoreService.get('currentBotType')] || (scenarioList[GlobalStoreService.get('currentBotType')] && scenarioList[GlobalStoreService.get('currentBotType')].length === 0)))) {
      return true
    }
    if (GlobalStoreService.get("APP_CONTEXT")) {
      if (!GlobalStoreService.get('loggedInToken')) {
        return true
      }
    }
    else {
      return false
    }

  }
  static returnSwipeGesture(position) {
    if (Math.abs(position.x) > Math.abs(position.y)) {
      // horizontal swipe
      return 'HORIZONTAL_SWIPE'
    }
    else {
      // vertical swipe
      return 'VERTICAL_SWIPE'
    }
  }

  static startScrollingRight = (id) => {

    let count = 0
    let count_limit = 13
    var myInterval = setInterval(() => {
      count++
      if (document.getElementById(id).scrollLeft === 0) {
        count_limit = 19
      }
      document.getElementById(id).scrollLeft = document.getElementById(id).scrollLeft + 10
      if (count > count_limit) {
        clearInterval(myInterval)
      }
    }, 10)
    this.myInterval = myInterval

  }
  static startScrollingLeft = (id) => {
    let count = 0
    var myInterval = setInterval(() => {
      count++
      document.getElementById(id).scrollLeft = document.getElementById(id).scrollLeft - 10
      if (count > 13) {
        clearInterval(myInterval)
      }
    }, 10)
    this.myInterval = myInterval

  }

  static getIosSpecificClass = () => {
    let platformType = UtilService.getPlatformTypeForTracking();
    if (platformType === TrackingPlatform.IOS_MSITE || platformType === TrackingPlatform.IOS_WEBVIEW)
      return "ios-scroll-fix"
    else
      return ""
  }

  static isBadFeedbackScenario = (current_scenario) => {

    if (current_scenario && current_scenario.scenario && current_scenario.scenario.scenarioId === GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]['BAD_FEEDBACK'].scenarioId) {
      return true
    }
    else
      return false
  }
  static isGridClickScenario = (current_scenario) => {
    let isGridClickScenario = false
    if (current_scenario && current_scenario.scenario && current_scenario.scenario.scenarioId) {
      switch (current_scenario.scenario.scenarioId) {
        case GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["WELCOME"].scenarioId:
        case GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["FAILURE"].scenarioId:
        case GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["NO_INTENT_FOUND_1"].scenarioId:
        case GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["NO_INTENT_FOUND_2"].scenarioId:
          {
            isGridClickScenario = true
            break;
          }
      }
    }
    return isGridClickScenario

  }

  static createUserMessageObject = (message, is_feedback) => {
    return {
      component_type: 'USER_RESPONSE',
      message: message,
      messageTime: UtilService.getCurrentTime(),
      is_feedback
    }
  }

  static createChatBotMessageObject = (message) => {
    return {
      component_type: 'DEFAULT',
      message: message,
      messageTime: UtilService.getCurrentTime()
    }
  }

  static disableActivateIrCardLink = () => {
    let ir_card_links = document.getElementsByClassName('ir-card-links')
    for (let i = 0; i < ir_card_links.length; i++) {
      ir_card_links[i].disabled = true
      ir_card_links[i].style.opacity = 0.5
    }
  }

  static disableDeactivateIrCardLink = () => {
    let ir_card_links = document.getElementsByClassName('dir-card-links')
    for (let i = 0; i < ir_card_links.length; i++) {
      ir_card_links[i].disabled = true
      ir_card_links[i].style.opacity = 0.5
    }
  }

  static disableSwitchMessageButtonClick = () => {
    let btns = document.getElementsByClassName('switch_msg_btn')
    for (let i = 0; i < btns.length; i++) {
      btns[i].disabled = true
      btns[i].style.opacity = 0.5
    }
  }

  static checkForCarouselWebScrollArrows() {

    let carousels = document.getElementsByClassName('monthly-plan')
    let carousel_arrows_div
    if (carousels && carousels.length > 0) {
      for (let i = 0; i < carousels.length; i++) {
        carousel_arrows_div = null
        if (carousels[i].childNodes && carousels[i].childNodes.length > 0) {
          for (let j = 0; j < carousels[i].childNodes.length; j++) {
            if (carousels[i].childNodes[j] && carousels[i].childNodes[j].classList.length > 0) {
              for (let k = 0; k < carousels[i].childNodes[j].classList.length; k++) {
                if (carousels[i].childNodes[j].classList[k] === "carousel_web_arrows") {
                  carousel_arrows_div = carousels[i].childNodes[j]
                }
                if (carousels[i].childNodes[j].classList[k] === "carousel_list") {
                  let list = carousels[i].childNodes[j]
                  if (!(list.scrollWidth > list.offsetWidth)) {
                    if (carousel_arrows_div) {
                      // set display property fro carousel arrows to none
                      carousel_arrows_div.remove()
                      return
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}








// WEBPACK FOOTER //
// ./src/services/util.service.js